import styled from 'styled-components';

export const AuthLoading = styled.main`
  background-color: ${(props) => props.theme.colors.primary500};
  min-height: 100vh;
`;
